var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.5,17.6L19,13.1c-0.5-0.5-1.2-0.4-1.6,0l-1.2,1.2c-0.7,0.7-1.8,0.7-2.4,0l-4.1-4.1C9,9.6,9,8.5,9.6,7.8 l1.2-1.2c0.5-0.5,0.5-1.2,0-1.6L6.4,0.5c-0.7-0.7-1.8-0.7-2.4,0L1.5,3c-1.6,1.6-1.9,4.4-0.8,6.3c0,0,1.3,3.1,6.2,7.9 s7.9,6.1,7.9,6.1c1.9,1.1,4.8,0.7,6.3-0.8l2.4-2.4C24.2,19.4,24.2,18.3,23.5,17.6z M19.4,20.9c-0.8,0.8-2.6,1-3.5,0.5 c0,0-0.4-0.2-0.6-0.3c-0.4-0.2-0.8-0.5-1.4-0.9c-1.6-1.1-3.4-2.6-5.4-4.6c-2-2-3.5-3.8-4.6-5.4C3.5,9.6,3.2,9.1,3,8.8 C2.8,8.5,2.6,8.1,2.6,8.1C2.1,7.1,2.3,5.4,3.1,4.6l2-2l3.3,3.3L8,6.2c-1.6,1.6-1.6,4.1,0,5.7l4.1,4.1c1.6,1.6,4.1,1.6,5.7,0l0.4-0.4 l3.3,3.3L19.4,20.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.154155b9353650b53f0422c3e40aa909.svg";
export { ForwardRef as ReactComponent };